import React, { useEffect, useState } from "react";
import axios from "axios";
import { getAccessToken } from "./auth";

async function fetch(): Promise<Item[]> {
  const token = await getAccessToken();

  const options = {
    method: "GET",
    url: "/api/v1/aliases",
    headers: { Authorization: `Bearer ${token}` },
  };

  const { data } = await axios.request(options);
  return data.aliases;
}

type Item = {
  alias: string;
  email: string;
  comment: string;
  createdAt: string;
  active: boolean;
};

function TableRow({ item }: { item: Item }) {
  const href = "mailto:" + item.email;
  const active = item.active ? "✅" : "⏸️";
  return (
    <div style={{ flex: 1 }}>
      <div className="detail-row">
        <div className="item icon">{active}</div>
        <div className="item">
          <a href={href}>{item.alias}</a>
        </div>
        <div className="item">{item.createdAt}</div>
      </div>
      <div className="comment-row">{item.comment}</div>
    </div>
  );
}
function Table({ items }: { items: Item[] }) {
  return (
    <div className="container-fluid">
      {items.map((item) => (
        <TableRow item={item} key={item.alias} />
      ))}
    </div>
  );
}
export default function List() {
  const [list, setList] = useState<Item[]>([]);

  useEffect(() => {
    const doFetch = async () => {
      try {
        const list = await fetch();
        console.log(list);
        setList(list.sort((a, b) => a.alias.localeCompare(b.alias)));
      } catch (error) {
        console.error(error);
      }
    };

    doFetch();
  }, []);
  return <Table items={list} />;
}
